import { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

// ─── Mapeo login sistema → clave tareas ───────────────────────────────────────
const LOGIN_TO_TAREAS = {
  'admin':      'admin',
  'gaby':       'GCHEVEZ',
  'davidv':     'DVITE',
  'alfonsogab': 'ALOZA',
};

// ─── Configuración usuarios ───────────────────────────────────────────────────
const USUARIOS = {
  admin:   { nombre: 'Gerente',      color: '#4361ee', inicial: 'DL' },
  GCHEVEZ: { nombre: 'Gabriela',     color: '#f72585', inicial: 'GC' },
  ALOZA:   { nombre: 'Alfonso Loza', color: '#4cc9f0', inicial: 'AL' },
  DVITE:   { nombre: 'David Vite',   color: '#4caf50', inicial: 'DV' },
};

const PRIORIDAD = {
  urgente: { label: 'Urgente', color: '#e63946', bg: '#2a0d0d', icon: '🔴' },
  normal:  { label: 'Normal',  color: '#ffc107', bg: '#2a1e00', icon: '🟡' },
  baja:    { label: 'Baja',    color: '#555',    bg: '#1a1a1a', icon: '🟢' },
};

const ESTADO = {
  pendiente:   { label: 'Pendiente',   color: '#aaa',    bg: '#1a1a1a',  icon: '⏳' },
  aceptada:    { label: 'Aceptada',    color: '#4cc9f0', bg: '#001a2a',  icon: '👍' },
  en_progreso: { label: 'En progreso', color: '#4361ee', bg: '#0d1a3e',  icon: '⚡' },
  bloqueada:   { label: 'Bloqueada',   color: '#ffc107', bg: '#2a1e00',  icon: '🚧' },
  completada:  { label: 'Completada',  color: '#4caf50', bg: '#0d2218',  icon: '✅' },
  cancelada:   { label: 'Cancelada',   color: '#555',    bg: '#1a1a1a',  icon: '❌' },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
function fmtFecha(s) {
  if (!s) return null;
  const d = new Date(s);
  return d.toLocaleDateString('es-EC', { day:'2-digit', month:'2-digit', year:'numeric' });
}
function fmtHora(s) {
  if (!s) return '';
  const d = new Date(s);
  return d.toLocaleString('es-EC', { day:'2-digit', month:'2-digit',
    hour:'2-digit', minute:'2-digit' });
}
function diasLabel(n) {
  if (n === null || n === undefined) return null;
  if (n < 0)  return `Venció hace ${Math.abs(n)}d`;
  if (n === 0) return 'Vence hoy';
  if (n <= 3)  return `${n}d restantes`;
  return `${n}d`;
}

// ─── Avatar usuario ───────────────────────────────────────────────────────────
function Avatar({ login, size = 28 }) {
  const u = USUARIOS[login] || { nombre: login, color: '#555', inicial: '?' };
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: `${u.color}22`, border: `1.5px solid ${u.color}55`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: u.color, fontWeight: 700,
      fontSize: size < 30 ? 9 : 11, flexShrink: 0,
    }}>{u.inicial}</div>
  );
}

// ─── Barra de progreso ────────────────────────────────────────────────────────
function BarraProgreso({ pct, estado, mini = false }) {
  const color = estado === 'completada' ? '#4caf50' :
                estado === 'cancelada'  ? '#555' :
                pct >= 75 ? '#4caf50' : pct >= 40 ? '#4361ee' : '#4cc9f0';
  const h = mini ? 4 : 6;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <div style={{ flex: 1, height: h, background: '#2a2a3e',
        borderRadius: h/2, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%',
          background: estado === 'cancelada' ? '#333' : color,
          borderRadius: h/2, transition: 'width .4s' }} />
      </div>
      {!mini && (
        <span style={{ color: '#555', fontSize: 10,
          fontFamily: 'monospace', minWidth: 28 }}>{pct}%</span>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// Modal Nueva Tarea
// ═══════════════════════════════════════════════════════════════════════════════
function ModalNuevaTarea({ usuarioActivo, onClose, onCreada }) {
  const [form, setForm] = useState({
    titulo: '', descripcion: '', prioridad: 'normal',
    asignada_a: '', fecha_limite: '',
  });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  async function guardar() {
    if (!form.titulo.trim() || !form.asignada_a) {
      setError('Título y destinatario son requeridos'); return;
    }
    setGuardando(true);
    try {
      const d = await api.post('/tareas', {
        ...form,
        creada_por: usuarioActivo,
        fecha_limite: form.fecha_limite || null,
      });
      if (d.ok) { onCreada(); onClose(); }
      else setError(d.error || 'Error al crear');
    } catch { setError('Error de conexión'); }
    setGuardando(false);
  }

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0,
        background:'rgba(0,0,0,0.65)', zIndex:200 }} />
      <div style={{
        position:'fixed', top:'50%', left:'50%',
        transform:'translate(-50%,-50%)',
        background:'#1e1e2e', borderRadius:14, padding:28,
        width:500, zIndex:201, border:'1px solid #2a2a3e',
        boxShadow:'0 16px 48px rgba(0,0,0,0.6)',
        display:'flex', flexDirection:'column', gap:16,
      }}>
        <div style={{ display:'flex', justifyContent:'space-between',
          alignItems:'center' }}>
          <div style={{ color:'#fff', fontWeight:700, fontSize:16 }}>
            ➕ Nueva Tarea
          </div>
          <button onClick={onClose} style={btnIconStyle}>✕</button>
        </div>

        {/* Título */}
        <div>
          <div style={labelStyle}>TÍTULO *</div>
          <input value={form.titulo}
            onChange={e => setForm(f => ({...f, titulo: e.target.value}))}
            placeholder="Ej: Imprimir facturas de Primefenix"
            autoFocus style={inputStyle} />
        </div>

        {/* Descripción */}
        <div>
          <div style={labelStyle}>DESCRIPCIÓN</div>
          <textarea value={form.descripcion}
            onChange={e => setForm(f => ({...f, descripcion: e.target.value}))}
            placeholder="Detalle adicional, instrucciones, referencias..."
            style={{ ...inputStyle, height: 72, resize: 'vertical' }} />
        </div>

        {/* Asignar a + Prioridad */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
          <div>
            <div style={labelStyle}>ASIGNAR A *</div>
            <select value={form.asignada_a}
              onChange={e => setForm(f => ({...f, asignada_a: e.target.value}))}
              style={inputStyle}>
              <option value="">Seleccionar...</option>
              {Object.entries(USUARIOS)
                .filter(([k]) => k !== usuarioActivo)
                .map(([k, u]) => (
                  <option key={k} value={k}>{u.nombre}</option>
                ))}
              <option value={usuarioActivo}>
                {USUARIOS[usuarioActivo]?.nombre} (yo mismo)
              </option>
            </select>
          </div>
          <div>
            <div style={labelStyle}>PRIORIDAD</div>
            <div style={{ display:'flex', gap:4 }}>
              {Object.entries(PRIORIDAD).map(([k, p]) => (
                <button key={k} onClick={() => setForm(f => ({...f, prioridad: k}))}
                  style={{
                    flex:1, padding:'7px 4px', borderRadius:7,
                    cursor:'pointer', fontSize:11,
                    background: form.prioridad===k ? p.bg : '#13131f',
                    border: `1px solid ${form.prioridad===k ? p.color : '#2a2a3e'}`,
                    color: form.prioridad===k ? p.color : '#555',
                  }}>
                  {p.icon}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Fecha límite */}
        <div>
          <div style={labelStyle}>FECHA LÍMITE (opcional)</div>
          <input type="date" value={form.fecha_limite}
            onChange={e => setForm(f => ({...f, fecha_limite: e.target.value}))}
            style={{ ...inputStyle, width: 'auto' }} />
        </div>

        {error && <div style={{ color:'#e63946', fontSize:12 }}>{error}</div>}

        <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
          <button onClick={onClose} style={btnCancelStyle}>Cancelar</button>
          <button onClick={guardar} disabled={guardando}
            style={{ ...btnPrimaryStyle, opacity: guardando ? 0.6 : 1 }}>
            {guardando ? 'Creando...' : '✅ Crear tarea'}
          </button>
        </div>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// Modal Detalle Tarea
// ═══════════════════════════════════════════════════════════════════════════════
function ModalDetalle({ tareaId, usuarioActivo, onClose, onRefresh }) {
  const [data,        setData]        = useState(null);
  const [progreso,    setProgreso]    = useState('');
  const [nota,        setNota]        = useState('');
  const [motivo,      setMotivo]      = useState('');
  const [delegarA,    setDelegarA]    = useState('');
  const [notaDelegac, setNotaDelegac] = useState('');
  const [guardando,   setGuardando]   = useState(false);
  const [accion,      setAccion]      = useState(null);
  // accion: 'progreso'|'delegar'|'cancelar'|'comentario'

  const cargar = useCallback(() => {
    api.get(`/tareas/${tareaId}`).then(d => {
      setData(d);
      setProgreso(String(d.tarea?.progreso || 0));
    });
  }, [tareaId]);

  useEffect(() => { cargar(); }, [cargar]);

  async function ejecutar(tipo) {
    setGuardando(true);
    try {
      let r;
      if (tipo === 'aceptar') {
        r = await api.patch(`/tareas/${tareaId}/aceptar`,
          { usuario: usuarioActivo });
      } else if (tipo === 'progreso') {
        r = await api.patch(`/tareas/${tareaId}/progreso`,
          { usuario: usuarioActivo, progreso: parseInt(progreso), nota });
      } else if (tipo === 'completar') {
        r = await api.patch(`/tareas/${tareaId}/completar`,
          { usuario: usuarioActivo, nota });
      } else if (tipo === 'cancelar') {
        if (!motivo.trim()) { setGuardando(false); return; }
        r = await api.patch(`/tareas/${tareaId}/cancelar`,
          { usuario: usuarioActivo, motivo });
      } else if (tipo === 'delegar') {
        if (!delegarA) { setGuardando(false); return; }
        r = await api.patch(`/tareas/${tareaId}/delegar`,
          { delegada_por: usuarioActivo, asignada_a: delegarA,
            nota: notaDelegac });
      } else if (tipo === 'comentario') {
        if (!nota.trim()) { setGuardando(false); return; }
        r = await api.post(`/tareas/${tareaId}/comentario`,
          { usuario: usuarioActivo, nota });
      }
      if (r?.ok) {
        setAccion(null); setNota(''); setMotivo('');
        setDelegarA(''); setNotaDelegac('');
        cargar(); onRefresh();
      }
    } catch {}
    setGuardando(false);
  }

  if (!data) return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0,
        background:'rgba(0,0,0,0.65)', zIndex:200 }} />
      <div style={{ position:'fixed', top:'50%', left:'50%',
        transform:'translate(-50%,-50%)', background:'#1e1e2e',
        borderRadius:14, padding:40, zIndex:201,
        color:'#555' }}>Cargando...</div>
    </>
  );

  const t      = data.tarea;
  const log    = data.log || [];
  const pr     = PRIORIDAD[t.prioridad] || PRIORIDAD.normal;
  const est    = ESTADO[t.estado]       || ESTADO.pendiente;
  const esMio  = t.asignada_a === usuarioActivo;
  const terminalState = ['completada','cancelada'].includes(t.estado);

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0,
        background:'rgba(0,0,0,0.65)', zIndex:200 }} />
      <div style={{
        position:'fixed', top:'50%', left:'50%',
        transform:'translate(-50%,-50%)',
        background:'#1e1e2e', borderRadius:14,
        width:620, maxHeight:'90vh',
        zIndex:201, border:'1px solid #2a2a3e',
        boxShadow:'0 16px 48px rgba(0,0,0,0.6)',
        display:'flex', flexDirection:'column',
        overflow:'hidden',
      }}>
        {/* Header */}
        <div style={{ padding:'20px 24px 16px',
          borderBottom:'1px solid #2a2a3e' }}>
          <div style={{ display:'flex', justifyContent:'space-between',
            alignItems:'flex-start', marginBottom:10 }}>
            <div style={{ flex:1, paddingRight:16 }}>
              <div style={{ display:'flex', alignItems:'center',
                gap:8, marginBottom:6 }}>
                <span style={{ fontSize:16 }}>{pr.icon}</span>
                <span style={{ background:est.bg, color:est.color,
                  border:`1px solid ${est.color}44`,
                  borderRadius:5, padding:'2px 8px',
                  fontSize:10, fontWeight:700 }}>
                  {est.icon} {est.label}
                </span>
                {t.dias_limite !== null && !terminalState && (
                  <span style={{
                    color: t.dias_limite < 0 ? '#e63946' :
                           t.dias_limite <= 3 ? '#ffc107' : '#555',
                    fontSize:10,
                  }}>📅 {diasLabel(t.dias_limite)}</span>
                )}
              </div>
              <div style={{ color:'#fff', fontWeight:700, fontSize:16,
                lineHeight:1.3 }}>{t.titulo}</div>
              {t.descripcion && (
                <div style={{ color:'#aaa', fontSize:13,
                  marginTop:6, lineHeight:1.5 }}>{t.descripcion}</div>
              )}
            </div>
            <button onClick={onClose} style={btnIconStyle}>✕</button>
          </div>

          {/* Meta info */}
          <div style={{ display:'flex', gap:16, alignItems:'center',
            flexWrap:'wrap' }}>
            <div style={{ display:'flex', alignItems:'center', gap:6 }}>
              <Avatar login={t.creada_por} />
              <span style={{ color:'#555', fontSize:11 }}>
                {t.creada_por_nombre} →
              </span>
              <Avatar login={t.asignada_a} />
              <span style={{ color:'#aaa', fontSize:11,
                fontWeight:600 }}>{t.asignada_a_nombre}</span>
            </div>
            {t.delegada_por && (
              <span style={{ color:'#555', fontSize:10 }}>
                (delegada por {t.delegada_por_nombre})
              </span>
            )}
            <span style={{ color:'#555', fontSize:10, marginLeft:'auto' }}>
              {fmtFecha(t.created_at)}
            </span>
          </div>

          {/* Barra progreso */}
          <div style={{ marginTop:12 }}>
            <BarraProgreso pct={t.progreso} estado={t.estado} />
          </div>
        </div>

        {/* Cuerpo scroll */}
        <div style={{ flex:1, overflowY:'auto',
          padding:'16px 24px', display:'flex',
          flexDirection:'column', gap:12 }}>

          {/* Acciones — solo si es mio y no terminado */}
          {esMio && !terminalState && (
            <div style={{ background:'#13131f', borderRadius:10,
              padding:'12px 14px' }}>
              <div style={{ color:'#aaa', fontSize:11,
                textTransform:'uppercase', letterSpacing:1,
                marginBottom:10 }}>Acciones</div>

              {/* Botones principales */}
              <div style={{ display:'flex', gap:6, flexWrap:'wrap',
                marginBottom: accion ? 12 : 0 }}>
                {t.estado === 'pendiente' && (
                  <button onClick={() => ejecutar('aceptar')}
                    style={{ ...btnAccionStyle, borderColor:'#4cc9f0',
                      color:'#4cc9f0', background:'#001a2a' }}>
                    👍 Aceptar
                  </button>
                )}
                <button onClick={() => setAccion(accion==='progreso' ? null : 'progreso')}
                  style={{ ...btnAccionStyle, borderColor:'#4361ee',
                    color:'#4361ee', background:'#0d1a3e' }}>
                  ⚡ Registrar avance
                </button>
                <button onClick={() => setAccion(accion==='delegar' ? null : 'delegar')}
                  style={{ ...btnAccionStyle, borderColor:'#ffc107',
                    color:'#ffc107', background:'#2a1e00' }}>
                  → Delegar
                </button>
                <button onClick={() => setAccion(accion==='comentario' ? null : 'comentario')}
                  style={{ ...btnAccionStyle, borderColor:'#555',
                    color:'#aaa', background:'#13131f' }}>
                  💬 Comentar
                </button>
                <button onClick={() => ejecutar('completar')}
                  style={{ ...btnAccionStyle, borderColor:'#4caf50',
                    color:'#4caf50', background:'#0d2218' }}>
                  ✅ Completar
                </button>
                <button onClick={() => setAccion(accion==='cancelar' ? null : 'cancelar')}
                  style={{ ...btnAccionStyle, borderColor:'#e63946',
                    color:'#e63946', background:'#2a0d0d' }}>
                  ❌ No puede completarse
                </button>
              </div>

              {/* Panel de acción activa */}
              {accion === 'progreso' && (
                <div style={{ display:'flex', flexDirection:'column',
                  gap:8, paddingTop:10,
                  borderTop:'1px solid #2a2a3e' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <span style={{ color:'#555', fontSize:12 }}>Progreso:</span>
                    <input type="range" min={0} max={100} step={5}
                      value={progreso}
                      onChange={e => setProgreso(e.target.value)}
                      style={{ flex:1 }} />
                    <span style={{ color:'#4361ee', fontFamily:'monospace',
                      fontWeight:700, fontSize:14, minWidth:36 }}>
                      {progreso}%
                    </span>
                  </div>
                  <BarraProgreso pct={parseInt(progreso)} estado="en_progreso" />
                  <input value={nota} onChange={e => setNota(e.target.value)}
                    placeholder="¿Qué hiciste? (opcional)"
                    style={inputStyle} />
                  <div style={{ display:'flex', gap:6,
                    justifyContent:'flex-end' }}>
                    <button onClick={() => setAccion(null)}
                      style={btnCancelStyle}>Cancelar</button>
                    <button onClick={() => ejecutar('progreso')}
                      disabled={guardando} style={btnPrimaryStyle}>
                      {guardando ? '...' : 'Guardar avance'}
                    </button>
                  </div>
                </div>
              )}

              {accion === 'delegar' && (
                <div style={{ display:'flex', flexDirection:'column',
                  gap:8, paddingTop:10, borderTop:'1px solid #2a2a3e' }}>
                  <div>
                    <div style={labelStyle}>Delegar a:</div>
                    <select value={delegarA}
                      onChange={e => setDelegarA(e.target.value)}
                      style={inputStyle}>
                      <option value="">Seleccionar...</option>
                      {Object.entries(USUARIOS)
                        .filter(([k]) => k !== usuarioActivo)
                        .map(([k, u]) => (
                          <option key={k} value={k}>{u.nombre}</option>
                        ))}
                    </select>
                  </div>
                  <input value={notaDelegac}
                    onChange={e => setNotaDelegac(e.target.value)}
                    placeholder="Motivo de la delegación (opcional)"
                    style={inputStyle} />
                  <div style={{ display:'flex', gap:6,
                    justifyContent:'flex-end' }}>
                    <button onClick={() => setAccion(null)}
                      style={btnCancelStyle}>Cancelar</button>
                    <button onClick={() => ejecutar('delegar')}
                      disabled={!delegarA || guardando}
                      style={{ ...btnPrimaryStyle,
                        background:'#ffc10722', borderColor:'#ffc107',
                        color:'#ffc107' }}>
                      {guardando ? '...' : '→ Delegar'}
                    </button>
                  </div>
                </div>
              )}

              {accion === 'cancelar' && (
                <div style={{ display:'flex', flexDirection:'column',
                  gap:8, paddingTop:10, borderTop:'1px solid #2a2a3e' }}>
                  <div style={{ color:'#e63946', fontSize:12 }}>
                    Explica por qué no puede completarse:
                  </div>
                  <textarea value={motivo}
                    onChange={e => setMotivo(e.target.value)}
                    placeholder="Ej: Primefenix no responde correos, pendiente contacto..."
                    style={{ ...inputStyle, height:64, resize:'vertical' }} />
                  <div style={{ display:'flex', gap:6,
                    justifyContent:'flex-end' }}>
                    <button onClick={() => setAccion(null)}
                      style={btnCancelStyle}>Cancelar</button>
                    <button onClick={() => ejecutar('cancelar')}
                      disabled={!motivo.trim() || guardando}
                      style={{ ...btnPrimaryStyle,
                        background:'#2a0d0d', borderColor:'#e63946',
                        color:'#e63946' }}>
                      {guardando ? '...' : '❌ Confirmar'}
                    </button>
                  </div>
                </div>
              )}

              {accion === 'comentario' && (
                <div style={{ display:'flex', flexDirection:'column',
                  gap:8, paddingTop:10, borderTop:'1px solid #2a2a3e' }}>
                  <textarea value={nota} onChange={e => setNota(e.target.value)}
                    placeholder="Escribe un comentario..."
                    autoFocus
                    style={{ ...inputStyle, height:72, resize:'vertical' }} />
                  <div style={{ display:'flex', gap:6,
                    justifyContent:'flex-end' }}>
                    <button onClick={() => setAccion(null)}
                      style={btnCancelStyle}>Cancelar</button>
                    <button onClick={() => ejecutar('comentario')}
                      disabled={!nota.trim() || guardando}
                      style={btnPrimaryStyle}>
                      {guardando ? '...' : '💬 Comentar'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Estado final */}
          {terminalState && t.motivo_cancelacion && (
            <div style={{ background:'#2a0d0d', borderRadius:8,
              padding:'10px 14px', border:'1px solid #e6394633' }}>
              <div style={{ color:'#e63946', fontSize:11,
                fontWeight:700, marginBottom:4 }}>MOTIVO DE CANCELACIÓN</div>
              <div style={{ color:'#ccc', fontSize:13 }}>
                {t.motivo_cancelacion}
              </div>
            </div>
          )}

          {/* Log de actividad */}
          <div>
            <div style={{ color:'#555', fontSize:11,
              textTransform:'uppercase', letterSpacing:1,
              marginBottom:10 }}>Actividad ({log.length})</div>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              {log.map((l, i) => {
                const u = USUARIOS[l.usuario] || { color:'#555', inicial:'?' };
                const esProgreso  = l.tipo === 'progreso';
                const esDelegacion= l.tipo === 'delegacion';
                const esEstado    = l.tipo === 'estado';
                const esComentario= l.tipo === 'comentario';

                return (
                  <div key={i} style={{
                    display:'flex', gap:10, alignItems:'flex-start',
                  }}>
                    <Avatar login={l.usuario} size={24} />
                    <div style={{ flex:1, background:'#13131f',
                      borderRadius:8, padding:'8px 12px' }}>
                      <div style={{ display:'flex',
                        justifyContent:'space-between',
                        alignItems:'center', marginBottom:3 }}>
                        <span style={{ color: u.color, fontSize:11,
                          fontWeight:700 }}>{l.usuario_nombre}</span>
                        <span style={{ color:'#444', fontSize:10 }}>
                          {fmtHora(l.fecha)}
                        </span>
                      </div>

                      {esProgreso && (
                        <div>
                          <div style={{ display:'flex', alignItems:'center',
                            gap:8, marginBottom:4 }}>
                            <span style={{ color:'#4361ee', fontSize:11 }}>
                              ⚡ Avance: {l.progreso_anterior}% →{' '}
                              <strong>{l.progreso_nuevo}%</strong>
                            </span>
                          </div>
                          <BarraProgreso pct={l.progreso_nuevo}
                            estado="en_progreso" mini />
                        </div>
                      )}
                      {esDelegacion && (
                        <span style={{ color:'#ffc107', fontSize:11 }}>
                          → Delegada a <strong>{l.asignado_nvo_nombre}</strong>
                        </span>
                      )}
                      {esEstado && (
                        <span style={{ color:'#aaa', fontSize:11 }}>
                          Estado: {l.estado_anterior} → {' '}
                          <strong style={{
                            color: ESTADO[l.estado_nuevo]?.color || '#aaa',
                          }}>
                            {ESTADO[l.estado_nuevo]?.icon}{' '}
                            {ESTADO[l.estado_nuevo]?.label}
                          </strong>
                        </span>
                      )}
                      {l.nota && (
                        <div style={{ color: esComentario ? '#ccc' : '#888',
                          fontSize: esComentario ? 13 : 11,
                          marginTop: esProgreso || esDelegacion ? 4 : 0,
                          fontStyle: esComentario ? 'normal' : 'italic',
                        }}>{l.nota}</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// Tarjeta de tarea
// ═══════════════════════════════════════════════════════════════════════════════
function TareaCard({ t, usuarioActivo, onClick }) {
  const pr  = PRIORIDAD[t.prioridad] || PRIORIDAD.normal;
  const est = ESTADO[t.estado]       || ESTADO.pendiente;
  const esMia   = t.asignada_a === usuarioActivo;
  const terminalState = ['completada','cancelada'].includes(t.estado);

  return (
    <div onClick={onClick} style={{
      background:'#1e1e2e', borderRadius:10,
      padding:'14px 16px', cursor:'pointer',
      border:`1px solid #2a2a3e`,
      borderLeft:`3px solid ${
        t.estado === 'completada' ? '#4caf50' :
        t.estado === 'cancelada'  ? '#444' :
        t.prioridad === 'urgente' ? '#e63946' :
        t.prioridad === 'normal'  ? '#ffc10755' : '#2a2a3e'
      }`,
      opacity: terminalState ? 0.7 : 1,
    }}>
      {/* Fila 1 — título + estado */}
      <div style={{ display:'flex', justifyContent:'space-between',
        alignItems:'flex-start', gap:10, marginBottom:8 }}>
        <div style={{ flex:1 }}>
          <div style={{ color:'#fff', fontSize:14, fontWeight:600,
            lineHeight:1.3 }}>
            {pr.icon} {t.titulo}
          </div>
          {t.descripcion && (
            <div style={{ color:'#555', fontSize:11, marginTop:3,
              whiteSpace:'nowrap', overflow:'hidden',
              textOverflow:'ellipsis' }}>
              {t.descripcion}
            </div>
          )}
        </div>
        <span style={{ background:est.bg, color:est.color,
          border:`1px solid ${est.color}44`,
          borderRadius:5, padding:'2px 7px',
          fontSize:9, fontWeight:700, whiteSpace:'nowrap',
          flexShrink:0 }}>
          {est.icon} {est.label}
        </span>
      </div>

      {/* Barra progreso */}
      {!terminalState && (
        <div style={{ marginBottom:8 }}>
          <BarraProgreso pct={t.progreso} estado={t.estado} />
        </div>
      )}

      {/* Fila inferior — personas + fecha */}
      <div style={{ display:'flex', justifyContent:'space-between',
        alignItems:'center' }}>
        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
          <Avatar login={t.creada_por} size={20} />
          <span style={{ color:'#444', fontSize:10 }}>→</span>
          <Avatar login={t.asignada_a} size={20} />
          <span style={{ color: esMia ? '#aaa' : '#555', fontSize:10 }}>
            {esMia ? '● Mía' : t.asignada_a_nombre}
          </span>
          {t.delegada_por && (
            <span style={{ color:'#555', fontSize:9 }}>
              (via {t.delegada_por_nombre})
            </span>
          )}
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          {t.num_updates > 0 && (
            <span style={{ color:'#444', fontSize:10 }}>
              💬{t.num_updates}
            </span>
          )}
          {t.dias_limite !== null && !terminalState && (
            <span style={{
              color: t.dias_limite < 0 ? '#e63946' :
                     t.dias_limite <= 3 ? '#ffc107' : '#555',
              fontSize:10,
            }}>📅 {diasLabel(t.dias_limite)}</span>
          )}
          {terminalState && t.fecha_completada && (
            <span style={{ color:'#555', fontSize:10 }}>
              {fmtFecha(t.fecha_completada)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// Componente principal
// ═══════════════════════════════════════════════════════════════════════════════
export default function TareasModule() {
  const { usuario } = useAuth();
  const usuarioActivo = LOGIN_TO_TAREAS[usuario?.usuario] || 'admin';

  const [data,         setData]         = useState(null);
  const [cargando,     setCargando]     = useState(true);
  const [vista,        setVista]        = useState('mias');
  const [estadoFiltro, setEstadoFiltro] = useState('todos');
  const [modalNueva,   setModalNueva]   = useState(false);
  const [tareaDetId,   setTareaDetId]   = useState(null);

  const cargar = useCallback(() => {
    setCargando(true);
    api.get(`/tareas?usuario=${usuarioActivo}&vista=${vista}&estado=${estadoFiltro}`)
      .then(d => { setData(d); setCargando(false); })
      .catch(() => setCargando(false));
  }, [usuarioActivo, vista, estadoFiltro]);

  useEffect(() => { cargar(); }, [cargar]);

  const tareas   = data?.tareas   || [];
  const conteos  = data?.conteos  || {};
  const totalActivas = (conteos['pendiente']||0) + (conteos['aceptada']||0)
                     + (conteos['en_progreso']||0) + (conteos['bloqueada']||0);

  return (
    <div style={{ fontFamily:"'Segoe UI', sans-serif", color:'#e0e0e0' }}>

      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between',
        alignItems:'center', marginBottom:20 }}>
        <div>
          <h2 style={{ color:'#fff', margin:0, fontSize:22, fontWeight:700 }}>
            📋 Tareas
          </h2>
          <div style={{ color:'#555', fontSize:13, marginTop:3 }}>
            Seguimiento de objetivos del equipo
          </div>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {/* Usuario activo — viene del login */}
          <div style={{
            display:'flex', alignItems:'center', gap:8,
            background:'#13131f', borderRadius:8, padding:'7px 12px',
            border:'1px solid #2a2a3e',
          }}>
            <Avatar login={usuarioActivo} size={22} />
            <span style={{ color:'#aaa', fontSize:12 }}>
              {USUARIOS[usuarioActivo]?.nombre}
            </span>
          </div>
          <button onClick={() => setModalNueva(true)} style={{
            background:'#4361ee', border:'none', color:'#fff',
            borderRadius:8, padding:'9px 20px',
            fontSize:13, fontWeight:700, cursor:'pointer',
          }}>+ Nueva tarea</button>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {[
          ['Activas',    totalActivas,              '#4361ee'],
          ['Pendientes', conteos['pendiente']  || 0, '#aaa'],
          ['En progreso',conteos['en_progreso']|| 0, '#4cc9f0'],
          ['Completadas',conteos['completada'] || 0, '#4caf50'],
          ['Canceladas', conteos['cancelada']  || 0, '#555'],
        ].map(([l, v, c]) => (
          <div key={l} style={{ background:'#1e1e2e', borderRadius:9,
            padding:'10px 16px', borderTop:`2px solid ${c}`,
            minWidth:100, textAlign:'center' }}>
            <div style={{ color:'#555', fontSize:10,
              textTransform:'uppercase', letterSpacing:1 }}>{l}</div>
            <div style={{ color:c, fontFamily:'monospace',
              fontWeight:700, fontSize:22, marginTop:4 }}>{v}</div>
          </div>
        ))}
      </div>

      {/* Controles */}
      <div style={{ display:'flex', gap:8, marginBottom:16,
        alignItems:'center', flexWrap:'wrap',
        borderBottom:'1px solid #2a2a3e', paddingBottom:12 }}>
        {/* Vista */}
        <div style={{ display:'flex', gap:0, background:'#13131f',
          borderRadius:8, overflow:'hidden' }}>
          {[
            { k:'mias',    l:'Mis tareas' },
            { k:'creadas', l:'Creadas por mí' },
            { k:'todas',   l:'Todas' },
          ].map(v => (
            <button key={v.k} onClick={() => setVista(v.k)} style={{
              background: vista===v.k ? '#2a2a3e' : 'none',
              border:'none', color: vista===v.k ? '#fff' : '#555',
              padding:'7px 14px', fontSize:12,
              fontWeight: vista===v.k ? 700 : 400, cursor:'pointer',
            }}>{v.l}</button>
          ))}
        </div>

        {/* Estado */}
        <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
          {['todos','pendiente','aceptada','en_progreso','bloqueada',
            'completada','cancelada'].map(e => {
            const est = ESTADO[e];
            return (
              <button key={e} onClick={() => setEstadoFiltro(e)} style={{
                background: estadoFiltro===e
                  ? `${est?.color || '#fff'}22` : '#1e1e2e',
                border:`1px solid ${estadoFiltro===e
                  ? est?.color || '#fff' : '#2a2a3e'}`,
                color: estadoFiltro===e ? est?.color || '#fff' : '#555',
                borderRadius:6, padding:'4px 10px',
                fontSize:10, fontWeight:600, cursor:'pointer',
              }}>
                {e === 'todos' ? 'Todos' : `${est?.icon} ${est?.label}`}
              </button>
            );
          })}
        </div>
      </div>

      {/* Lista de tareas */}
      {cargando ? (
        <div style={{ color:'#555', textAlign:'center', padding:40 }}>
          Cargando...
        </div>
      ) : tareas.length === 0 ? (
        <div style={{ color:'#555', textAlign:'center', padding:40,
          fontSize:14 }}>
          Sin tareas para mostrar
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {tareas.map(t => (
            <TareaCard key={t.id} t={t}
              usuarioActivo={usuarioActivo}
              onClick={() => setTareaDetId(t.id)}
            />
          ))}
        </div>
      )}

      {/* Modales */}
      {modalNueva && (
        <ModalNuevaTarea
          usuarioActivo={usuarioActivo}
          onClose={() => setModalNueva(false)}
          onCreada={cargar}
        />
      )}
      {tareaDetId && (
        <ModalDetalle
          tareaId={tareaDetId}
          usuarioActivo={usuarioActivo}
          onClose={() => setTareaDetId(null)}
          onRefresh={cargar}
        />
      )}
    </div>
  );
}

// ─── Estilos ──────────────────────────────────────────────────────────────────
const inputStyle = {
  background:'#13131f', border:'1px solid #2a2a3e',
  borderRadius:7, color:'#fff', padding:'8px 10px',
  fontSize:12, outline:'none', width:'100%',
  boxSizing:'border-box',
};
const labelStyle = {
  color:'#555', fontSize:10, textTransform:'uppercase',
  letterSpacing:0.5, marginBottom:4,
};
const btnPrimaryStyle = {
  background:'#4361ee', border:'1px solid #4361ee',
  borderRadius:7, color:'#fff', padding:'7px 18px',
  fontSize:12, fontWeight:700, cursor:'pointer',
};
const btnCancelStyle = {
  background:'none', border:'1px solid #2a2a3e',
  borderRadius:7, color:'#aaa', padding:'7px 16px',
  fontSize:12, cursor:'pointer',
};
const btnAccionStyle = {
  background:'transparent', border:'1px solid',
  borderRadius:7, padding:'6px 12px',
  fontSize:11, fontWeight:700, cursor:'pointer',
};
const btnIconStyle = {
  background:'none', border:'none', color:'#555',
  fontSize:20, cursor:'pointer', padding:4,
};